import {withNamespaces} from "react-i18next";
import React, {useEffect, useState} from "react";
import ReactLoading from "react-loading";
import axios from "axios";
import SimpleBar from "simplebar-react";
import {confirmAlert} from "react-confirm-alert";

const ReservierungsListe = ({translation, filterOptions, onEdit}) => {
    const [loaderShow, setLoaderShow] = useState(false);
    const [buchungen, setBuchungen] = useState([]);

    const activeRights = JSON.parse(localStorage.getItem("rights"));
    const link = localStorage.getItem('link') + '/api/ReservationService';

    let selectedDepartment = filterOptions.department;
    let fromFilter = filterOptions.from;
    let tillFilter = filterOptions.till;

    axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("JWT");
    useEffect(() => {
        loadData();
    }, [filterOptions]);

    const loadData = () => {
        if (selectedDepartment == null) {
            return;
        }
        
        setLoaderShow(true);

        const request = {
            departmentId: selectedDepartment?.value ?? '',
            from: fromFilter?.toISOString() ?? '',
            till: tillFilter?.toISOString() ?? '',
        }
        const searchParams = new URLSearchParams(request).toString();
        const getDataLink = link + '?' + searchParams;
        
        axios.get(getDataLink, {}).then((response) => {
            setBuchungen(response.data);
            setLoaderShow(false);
        })
            .catch((error) => {
                console.error("Error while loading Data", error);
                setLoaderShow(false);
            });
    }

    const deleteEntry = (entry) => {
        confirmAlert({
            message: translation("allgemein.bestaetigen"),
            buttons: [
                {
                    label: translation("allgemein.ja"),
                    onClick: () =>
                        axios
                            .delete(link + '?id=' + entry.id)
                            .then((response) => {
                                setBuchungen(b => b.filter(b => b.id !== entry.id));
                            })

                            .catch((error) => {
                                console.error("Error while deleting", error);
                            }),
                },
                {
                    label: translation("allgemein.nein"),
                },
            ],
        }); 
    }

    function getHtmlList() {
        let htmlList = [];

        for (let i = 0; i < buchungen.length; i++) {
            let buchung = buchungen[i];

            htmlList.push(
                <tr key={buchung.id}>
                    <td>{buchung.creatorUserName}</td>
                    <td>{buchung.departmentName}</td>
                    <td>{buchung.numberPlate}</td>
                    <td>{new Date(buchung.permissionFrom).toLocaleString()}</td>
                    <td>{new Date(buchung.permissionTill).toLocaleString()}</td>
                    {/*<td>{buchung.reservedLotName}</td>*/}
                    <td>{buchung.parkingLotPreference}</td>
                    <td>{buchung.scenarioName}</td>
                    <td>{buchung.company}</td>
                    <td>{buchung.firstname} {buchung.lastname}</td>
                    {/*<td>{buchung.eMail}</td>*/}
                    <td>
                        {activeRights.find((item) => item.includes("ReservationService.Update")) && (
                            <i
                                className="bx bx-edit bx-sm"
                                id="pop-up-button"
                                title={translation("allgemein.Bearbeiten")}
                                onClick={() => onEdit(buchung.id)}
                            />)
                        }

                        {activeRights.find((item) => item.includes("ReservationService.Delete")) && (
                            <i
                                className="bx bx-trash bx-sm"
                                id="pop-up-button"
                                style={{marginLeft: "10px"}}
                                title={translation("allgemein.Loeschen")}
                                onClick={() => deleteEntry(buchung)}
                            />)
                        }
                    </td>
                </tr>
            );
        }

        return <tbody>{htmlList}</tbody>;
    }

    let header = translation("reservationService.reservationList");
    if (selectedDepartment?.value > 0) {
        header += ` ${translation("userDepartments.department")}: ${selectedDepartment.label}`;
    }
    if (fromFilter) {
        header += ` ${translation("allgemein.von")}: ${fromFilter.toLocaleString()}`;
    }
    if (tillFilter) {
        header += ` ${translation("allgemein.bis")}: ${tillFilter.toLocaleString()}`;
    }
    return (
        <SimpleBar style={{ width: "100%", height: "100%" }}>
            <div
                id="settings-page-view-container"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                }}
            >
            <div className="einstellungen-box">
                <h2>Parking Scenarios</h2>
                
                
                <div className="box-name">{header}</div>
                <div style={{overflow: "auto"}}>
                    {loaderShow === true && (
                        <div style={{position: "absolute"}}>
                            <ReactLoading
                                type={"bars"}
                                color={"#2a3042"}
                                height={80}
                                width={80}
                                name={"Loading"}
                            />
                        </div>
                    )}

                    <table id="dataTable">
                        <thead>
                        <tr>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.creator")}</th>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.department")}</th>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.numberPlate")}</th>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.from")}</th>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.till")}</th>
                            {/*<th style={{textAlign: "center"}}>{translation("reservationService.listHeader.reservedLot")}</th>*/}
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.lotPreference")}</th>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.scenario")}</th>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.company")}</th>
                            <th style={{textAlign: "center"}}>{translation("reservationService.listHeader.name")}</th>
                            {/*<th style={{textAlign: "center"}}>{translation("reservationService.listHeader.email")}</th>*/}
                            <th style={{textAlign: "center"}}>
                                {activeRights.find((item) => item.includes("ReservationService.Create")) && (
                                    <button className="button" id="pop-up-button" style={{width: "50px"}} onClick={() => onEdit()}>
                                        {translation("allgemein.neu")}
                                    </button>)
                                }
                            </th>
                        </tr>
                        </thead>
                        {getHtmlList()}
                    </table>
                </div>
            </div>
        </div>
        </SimpleBar>
    );
};

export default withNamespaces()(ReservierungsListe);
